import type { ResultsOfflineRequestCopy } from '@voll-intelligence/intelligence-ui-kit';
import type { GenUiTranslate } from '@voll-intelligence/genui-contract';

/** Quem monta o banner — a copy compartilhada é `resultsOffline.*`; o que muda
 *  por domínio (a oferta e a explicação) vem do próprio namespace de cada página. */
export type OfflineRequestDomain = 'hotel' | 'flight';

const DOMAIN_PREFIX = {
  hotel: 'hotel.results.offline',
  flight: 'flightExplorer.offline',
} as const;

/** A copy do `ResultsOfflineRequest` (intelligence-ui-kit) no vocabulário do
 *  kit, para a página de hotel e o explorer de voo. */
export function offlineRequestCopy(
  t: GenUiTranslate,
  domain: OfflineRequestDomain,
): ResultsOfflineRequestCopy {
  const prefix = DOMAIN_PREFIX[domain];
  return {
    offerTitle: t(`${prefix}.offerTitle`),
    offerBody: t(`${prefix}.offerBody`),
    offerAction: t('resultsOffline.offerAction'),
  };
}
